import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProgressToast } from '../../../services/progress-toast.service';
import { ProgressArchiveToastsItemComponent } from '../progress-archive-toasts-item/progress-archive-toasts-item.component';
import { ProgressUploadToastsItemComponent } from '../progress-upload-toasts-item/progress-upload-toasts-item.component';

@Component({
  selector: 'app-progress-toasts-item',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProgressUploadToastsItemComponent, ProgressArchiveToastsItemComponent],
  templateUrl: './progress-toasts-item.component.html',
  styleUrl: './progress-toasts-item.component.scss',
})
export class ProgressToastsItemComponent {
  @Input({ required: true }) toast: ProgressToast;
}
